<div class="drawer-header border-bottom">
    <span class="title">Detalhes da empresa</span>
    <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer p-4">

    <div class="basic-info">
        <div class="avatar">
            <p-avatar
              *ngIf="!empresaImageError && imagePreview; else defaultCompanyAvatar"
              [image]="$any(imagePreview)"
              (onImageError)="empresaImageError = true"
              shape="circle"
              size="xlarge"
            />
            <ng-template #defaultCompanyAvatar>
              <p-avatar
                [label]="getInitials(perfilEmpresa?.nome)"
                [icon]="!perfilEmpresa?.nome ? 'pi pi-building' : undefined"
                shape="circle"
                size="xlarge"
              />
            </ng-template>
        </div>
        <div class="details">
            <div class="name-area">
                <div class="left-area">
                    <div class="title-header">
                        <span class="name">{{perfilEmpresa?.nome}}</span>
                        <div class="info">
                            <span> <strong>{{perfilEmpresa?.subSector | subSector}} </strong></span>
                            <span>•</span>
                            <span>
                                <p-tag *ngIf="perfilEmpresa?.estadoContratoDescricao === 'Activo'" severity="success"
                                    value="Activo" />
                                <p-tag *ngIf="perfilEmpresa?.estadoContratoDescricao === 'Inactivo'" severity="danger"
                                    value="Inactivo" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <p-splitbutton (onClick)="aprovarCandidatura()" label="Aprovar" [model]="items" /> -->
    </div>
    <div class="d-flex justify-content-between gap-3 mt-4">
        <div class="card-info w-50">
            <div class="icon">
                <i class="pi pi-phone"></i>
            </div>
            <div class="description">
                <span class="title">Telefone</span>
                <span class="info mt-2"><strong> {{perfilEmpresa?.telefone}} </strong></span>
                <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
            </div>
        </div>
        <div class="card-info w-50">
            <div class="icon">
                <i class="pi pi-envelope"></i>
            </div>
            <div class="description">
                <span class="title">Email</span>
                <span class="info">{{ perfilEmpresa?.email }}</span>
            </div>
        </div>
    </div>
    <div class="endereco">
        <div class="icon">
            <i class="pi pi-map-marker"></i>
        </div>
        <div class="description">
            <span class="info mt-2"><strong> {{perfilEmpresa?.localizacao}} </strong></span>
            <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
        </div>
    </div>
    <div class="site-url">
        <div class="icon">
            <i class="pi pi-globe"></i>
        </div>
        <div class="description">
            <span class="info mt-2"><strong> {{perfilEmpresa?.url}} </strong></span>
            <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
        </div>
    </div>
    <div class="avatar-info">
        <div class="flex flex-column align-items-center justify-content-center gap-2">
            <p-avatar-group *ngIf="companyProfissionais.length > 0; else noMaisProfissionais">
                <p-avatar
                  *ngFor="let prof of companyProfissionais"
                  [image]="!prof.imageError && prof.photoUrl ? prof.photoUrl : undefined"
                  [label]="prof.imageError || !prof.photoUrl ? getInitials(prof.nome) : undefined"
                  [icon]="(prof.imageError || !prof.photoUrl) && !prof.nome ? 'pi pi-user' : undefined"
                  (onImageError)="prof.imageError = true"
                  shape="circle"
                  [pTooltip]="prof.nome"
                  tooltipPosition="top"
                />
                <p-avatar
                  *ngIf="profissionaisCount > companyProfissionais.length"
                  [label]="'+' + (profissionaisCount - companyProfissionais.length)"
                  shape="circle"
                  [style]="{ 'background-color': '#eef2ff', 'color': '#4864E1', 'font-weight': '600' }"
                />
            </p-avatar-group>
            <ng-template #noMaisProfissionais>
                <p-avatar icon="pi pi-users" shape="circle" size="large" />
            </ng-template>
            <p class="m-0 text-secondary">{{ profissionaisCount }} Profissionais contratados via plataforma</p>
        </div>
    </div>
    <div class="about">
        <h3 class="title">Descrição da empresa</h3>
        <p> {{perfilEmpresa?.descricaoEmpresa}} </p>
    </div>
</div>